module.exports = __webpack_public_path__ + "img/interface_altar.d01733fe.png";